import React, { FC } from 'react';

import { Link } from 'react-router-dom';

import useBookingRootLink from '../../../../hooks/useBookingRootLink';
import i18n from '../../../../providers/Locale';
import Button from '../../../ui/Button';
import DeclinedIcon from '../../../ui/icons/Declined';

import styles from './styles.module.scss';

type PaymentErrorProps = {
	isPaidBooking: boolean;
};

const PaymentError: FC<PaymentErrorProps> = ({ isPaidBooking }) => {
	const bookingRootLink = useBookingRootLink();

	return (
		<div className={styles.paymentError}>
			<div className={styles.paymentErrorIcon}>
				<DeclinedIcon />
			</div>
			{isPaidBooking && (
				<div className={styles.paymentErrorText}>{i18n('booking.paid.error_msg')}</div>
			)}
			<div className={styles.paymentErrorBtn}>
				<Link to={bookingRootLink}>
					<Button fullWidth appearance="primary">
						{i18n('try_again')}
					</Button>
				</Link>
			</div>
		</div>
	);
};

export default PaymentError;
